export const cleanHTMLFromClasses = (html: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const elementsWithClass = doc.querySelectorAll('*[class]');
  elementsWithClass.forEach((element) => {
    element.removeAttribute('class');
  });

  const cleanHtml = doc.body.innerHTML;
  return cleanHtml;
};
